import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import EditFreeVideoLayer from "../components/EditFreeVideoLayer";
 
 
const EditFreeVideoPage = () => {
  return (
    <>
   
        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Edit Free Video  </h5><Breadcrumb title="Edit Free Video" /></div>
 
        {/* CalendarMainLayer */}
        <EditFreeVideoLayer />
 
 
    </>
  );
};
 
export default EditFreeVideoPage;
 
 